import { FC } from "react";
import Logo from "@/components/logo";
import CloseCircle from "@/assets/images/CloseCircle";
import { Button } from "@/components/button";
import { useTranslation } from "react-i18next";
import { StillThereModal } from "@/components/still-there-modal";
import styles from "./FailedPaymentScreen.module.scss";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/types/routes";

const FailedPaymentScreen: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onBackToReceiptPress = () => navigate(Routes.MAIN);
  const onStartOverPress = () => navigate(Routes.START);

  return (
    <div className={styles.container}>
      <StillThereModal />
      <Logo className={styles.logo} returnUrlButtonColor="white" returnUrlButtonTextColor="black" />
      <div className={styles.content}>
        <CloseCircle />
        <h1 data-cy="failed-payment-screen-title">{t("failedPayment.title")}</h1>
        <p>{t("errorScreen.subTitle")}</p>
        <div className={styles.buttonWrapper}>
          <Button
            text={t("failedPayment.backToReceipt")}
            onClick={onBackToReceiptPress}
            size="small"
            color="white"
            textColor="black"
            data-cy="back-to-receipt-button"
          />
          <Button
            text={t("failedPayment.startOver")}
            onClick={onStartOverPress}
            size="small"
            color="transparent"
            textColor="white"
            className={styles.startOverButton}
          />
        </div>
      </div>
    </div>
  );
};

export default FailedPaymentScreen;
